import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import clsx from 'clsx';
import { LANGUAGES, useLanguage } from '../utils/language';
import type { SupportedLanguage } from '../i18n';

/** Sprachauswahl fuer die oeffentlichen Seiten (Landing, Pakete). Ohne Anmeldung wird die
 * Sprache nur lokal gespeichert; bei der Registrierung uebernimmt das Backend sie ins Konto. */
export const PublicLanguageSelect: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();

  return (
    <label className={clsx('flex items-center gap-2 text-dark-300', className)}>
      <Globe size={18} className="shrink-0" />
      <select
        aria-label={t('nav:sidebar.language')}
        title={t('nav:sidebar.language')}
        value={language}
        onChange={(e) => void changeLanguage(e.target.value as SupportedLanguage, false)}
        className="rounded-lg border border-dark-700 bg-dark-800 px-2 py-1.5 text-sm text-dark-200"
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.id} value={lang.id}>
            {lang.label}
          </option>
        ))}
      </select>
    </label>
  );
};
